import { Subject } from "rxjs";
import { ActionBarHandlerModel } from ".";

export class ActionbarNotifier {
    init: (handler: ActionBarHandlerModel) => void = (handler: ActionBarHandlerModel) => { };
    updateState: (handler: ActionBarHandlerModel) => void = (handler: ActionBarHandlerModel) => { };
    getCurrentState: () => ActionBarHandlerModel = () => { return null; };
    action$: Subject<string> = new Subject<string>();
}